<template>
  <el-date-picker
    class="sr-date-time"
    :type="item.timeType ? item.timeType : 'datetime'"
    :disabled="item.disabled"
    v-model="date"
    :placeholder="item.placeholder"
    start-placeholder="开始日期"
    end-placeholder="结束日期"
    :clearable="false"
    @change="
      (val) => {
        change(val);
      }
    "
    :format="item.format ? item.format : 'yyyy-MM-dd HH:mm:ss'"
    :value-format="item.format ? item.format : 'yyyy-MM-dd HH:mm:ss'"
    :range-separator="item.range ? item.range : ' - '"
    :picker-options="item.pickerOptions ? item.pickerOptions : {}"
  ></el-date-picker>
</template>

<!--
  功能：下拉框组件
  汪振涛
  时间：2020年11月19日 17:09:02
  版本：v1.0
-->
<script>
export default {
  name: "SrDatetime",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: String | Number,
    item: {
      type: Object | Array,
      default: {},
    },
  },
  data() {
    return {
      date: this.value,
    };
  },
  watch: {
    value: {
      handler(val) {
        this.date = val;
      },
      deep: true,
    },
  },
  methods: {
    change(value) {
      
      this.$emit("change", value);
    },
    /**
     * 时间选择限制
     */
    disabledDate() {
      return false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// packages/SrDatetime/SrDatetime.vue